/**
 *
 *  Time Slots panel (Repeat Booking Flow for mobiles)
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 25/04/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useRef } from "react";
import PropTypes from "prop-types"; // use directly
import moment from "moment";

// Components
import Button from "../Button/Button";
import BookingFlowDayTimeSelector from "../BookingFlow/DayTimeSelector/DayTimeSelector";

// Icons
import ArrowRightIcon from "../../icons/ArrowRightIcon";

const RepeatBookingFlowPanel = ({
  className,
  disabled,
  isFetching,
  isFullyOpen,
  region,
  bookingTime,
  min,
  max,
  availableDays,
  partnerAvailability,
  partnerAvailabilityLoaded,
  onDateTimeSelect,
  onCtaClick,
}) => {
  const dayTimePickerRef = useRef();

  /*
   * @param {Date} dateTime
   * @param {String} dateStr - formatted string
   * @param {boolean} time - is time selected
   *
   */
  const handleDateTimeSelect = (dateTime, dateStr, time) => {
    // Pass through callback to parent
    onDateTimeSelect && onDateTimeSelect(dateTime, time);
  };

  const isOnline = false;

  return (
    <aside
      className={`booking-flow-panel tbk-z-995 tbk-flex tbk-h-full tbk-flex-col tbk-bg-basic-white ${className}`}
    >
      <div className="booking-flow-panel-body tbk-text-main tbk-grow">
        <BookingFlowDayTimeSelector
          id="booking_flow_panel"
          disabled={disabled || isFetching}
          isFullyOpen={isFullyOpen}
          className={`booking-datetime-picker-input_what ${
            isOnline ? "virtual" : "in-person"
          }`}
          availableDays={availableDays}
          region={region}
          view="week"
          min={min}
          max={max}
          minTime="5:30"
          format="DD MMM, hh:mm A"
          headerFormat="MMMM"
          footerFormat="DD MMM"
          timeFormat="HH:mm"
          partnerAvailability={partnerAvailability}
          partnerAvailabilityLoaded={partnerAvailabilityLoaded}
          step={30}
          bookingTime={bookingTime && moment(bookingTime).toDate()}
          timeComponent={({ item }) => (
            <button type="button" disabled={item.disabled}>
              {item.label}
            </button>
          )}
          onDateTimeSelect={handleDateTimeSelect}
          ref={dayTimePickerRef}
        />
      </div>
      <div className="tbk-absolute tbk-left-0 tbk-right-0 tbk-bottom-0 tbk-shrink-0 tbk-bg-basic-white tbk-px-2">
        <Button
          className="tbk-mb-3 tbk-w-full"
          onClick={onCtaClick}
          endIcon={<ArrowRightIcon />}
        >
          Proceed
        </Button>
      </div>
    </aside>
  );
};

RepeatBookingFlowPanel.propTypes = {
  sessionType: PropTypes.string,
  isFullyOpen: PropTypes.bool.isRequired,
  bookingTime: PropTypes.instanceOf(Date),
  partnerSummary: PropTypes.shape({
    firstName: PropTypes.string,
    id: PropTypes.number,
    lastName: PropTypes.string,
    phoneNumber: PropTypes.string,
    products: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      })
    ),
    region: PropTypes.string,
  }),
  partnerAvailability: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.string,
    })
  ),
  partnerAvailabilityLoaded: PropTypes.bool,
  clearPartnerAvailabilityLoaded: PropTypes.func,
  onCtaClick: PropTypes.func,
  onDateTimeSelect: PropTypes.func.isRequired,
};

RepeatBookingFlowPanel.defaultProps = {};

export default RepeatBookingFlowPanel;
